import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './onboarding.module.css';
import TourCard from './TourCard';
import STEPS, { ANCHORS, isStepAvailable, selectorFor } from './onboardingSteps';
import { computeCardPosition } from './tourPosition';
import { getLocale } from './locales';
import { ONBOARDING_EVENTS, trackOnboarding } from './onboardingAnalytics';
import { useOnboarding } from './onboardingContext';
import alert from '../../helpers/alert';

// Ð¡Ð°Ð¼ ÑÑÑ: Ð·Ð°ÑÐµÐ¼Ð½ÑÐµÑ ÑÐºÑÐ°Ð½, Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¸Ð²Ð°ÐµÑ Ð½ÑÐ¶Ð½ÑÐ¹ ÑÐ»ÐµÐ¼ÐµÐ½Ñ Ð¸ Ð²ÐµÐ´ÑÑ Ð¿Ð¾ ÑÐ°Ð³Ð°Ð¼.
//
// ÐÐ¸Ð±Ð»Ð¸Ð¾ÑÐµÐºÑ Ð½Ðµ Ð±ÐµÑÑÐ¼ Ð½Ð°Ð¼ÐµÑÐµÐ½Ð½Ð¾. ÐÑ Ð½ÐµÑ Ð½ÑÐ¶Ð½Ñ ÑÐ¾Ð²Ð½Ð¾ Ð´Ð²Ðµ Ð²ÐµÑÐ¸ â Ð²ÑÑÐµÐ· Ð²
// Ð·Ð°ÑÐµÐ¼Ð½ÐµÐ½Ð¸Ð¸ Ð¸ Ð²ÑÐ±Ð¾Ñ ÑÑÐ¾ÑÐ¾Ð½Ñ Ð´Ð»Ñ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸; Ð¾Ð±Ðµ Ð»ÐµÐ¶Ð°Ñ Ð½Ð¸Ð¶Ðµ Ð¸ Ð·Ð°Ð½Ð¸Ð¼Ð°ÑÑ Ð¿Ð°ÑÑ
// Ð´ÐµÑÑÑÐºÐ¾Ð² ÑÑÑÐ¾Ðº. ÐÐ°ÑÐ¾ ÐºÐ°ÑÑÐ¾ÑÐºÐ° ÑÐ²Ð¾Ñ (Ð´Ð²Ð° Ð±ÑÐµÐ½Ð´Ð°, ÑÐ²Ð¾Ð¸ ÑÐ²ÐµÑÐ° Ð¸ ÑÑÐ¸ÑÑÑ), Ð½ÐµÑ
// Ð½Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÐ¸ Ð² ÑÐ±Ð¾ÑÐºÐµ, ÐºÐ¾ÑÐ¾ÑÐ°Ñ ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑÑÑ Ð½Ð° node 14, Ð¸ ÑÐ°Ð³ Ñ
// Ð¿ÑÐ¾Ð¿Ð°Ð²ÑÐ¸Ð¼ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ¾Ð¼ Ð¼Ñ Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÐ¼ Ð¿Ð¾ ÑÐ²Ð¾Ð¸Ð¼ Ð¿ÑÐ°Ð²Ð¸Ð»Ð°Ð¼.

const CARD_FALLBACK = { width: 320, height: 180 };

// Ð¡ÐºÐ¾Ð»ÑÐºÐ¾ Ð¶Ð´ÑÐ¼, Ð¿Ð¾ÐºÐ° Ð¾ÑÐºÑÑÐ²ÑÐ¸Ð¹ÑÑ ÑÐ°Ð·Ð´ÐµÐ» Ð½Ð°ÑÐ¸ÑÑÐµÑ Ð½ÑÐ¶Ð½ÑÐ¹ ÑÐ»ÐµÐ¼ÐµÐ½Ñ: Ð´Ð²Ð°Ð´ÑÐ°ÑÑ
// Ð¿Ð¾Ð¿ÑÑÐ¾Ðº Ð¿Ð¾ 100 Ð¼Ñ â Ð´Ð²Ðµ ÑÐµÐºÑÐ½Ð´Ñ. ÐÐµ Ð´Ð¾Ð¶Ð´Ð°Ð»Ð¸ÑÑ â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÑ Ð±ÐµÐ·
// Ð¿Ð¾Ð´ÑÐ²ÐµÑÐºÐ¸, ÑÑÐ¾Ð±Ñ ÑÑÑ Ð½Ðµ Ð²ÑÑÐ°Ð²Ð°Ð».
const WAIT_ATTEMPTS = 20;
const WAIT_STEP_MS = 100;

// ÐÐµÐ½Ñ Ð¶Ð´ÑÐ¼ Ð´Ð¾Ð»ÑÑÐµ: Ð¾Ð½Ð¾ Ð¿Ð¾ÑÐ²Ð»ÑÐµÑÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð´Ð²ÑÑ Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð² Ðº ÑÐµÑÐ²ÐµÑÑ, Ð° Ð½Ð°
// Ð¼ÐµÐ´Ð»ÐµÐ½Ð½Ð¾Ð¹ ÑÐ²ÑÐ·Ð¸ ÑÑÐ¾ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐµÐºÑÐ½Ð´. ÐÐµ Ð´Ð¾Ð¶Ð´Ð°Ð»Ð¸ÑÑ â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐ¾, ÑÑÐ¾
// ÐµÑÑÑ, Ð»Ð¸ÑÑ Ð±Ñ ÑÑÑ Ð½Ðµ Ð²Ð¸ÑÐµÐ».
const MENU_WAIT_ATTEMPTS = 50;

const OnboardingTour = () => {
  const { tourRunning, finishTour } = useOnboarding();
  const locale = getLocale();
  const navigate = useNavigate();
  const location = useLocation();

  const [steps, setSteps] = useState([]);
  const [index, setIndex] = useState(0);
  const [rect, setRect] = useState(null);
  const [cardSize, setCardSize] = useState(CARD_FALLBACK);

  const cardRef = useRef(null);
  // ÐÑÐºÑÐ´Ð° ÑÐµÐ»Ð¾Ð²ÐµÐº Ð½Ð°ÑÐ°Ð» Ð¾Ð±ÑÑÐµÐ½Ð¸Ðµ: Ð² ÐºÐ¾Ð½ÑÐµ Ð²ÐµÑÐ½ÑÐ¼ ÐµÐ³Ð¾ Ð½Ð° ÑÑ Ð¶Ðµ ÑÑÑÐ°Ð½Ð¸ÑÑ.
  const startPath = useRef(null);

  // Ð¡Ð¿Ð¸ÑÐ¾Ðº ÑÐ°Ð³Ð¾Ð² ÑÐ¸ÐºÑÐ¸ÑÑÐµÐ¼ Ð½Ð° ÑÑÐ°ÑÑÐµ: Ð¸Ð½Ð°ÑÐµ ÑÑÑÑÑÐ¸Ðº Â«3 Ð¸Ð· 9Â» Ð¿ÑÑÐ³Ð°Ð» Ð±Ñ,
  // ÐºÐ¾Ð³Ð´Ð° Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ Ð¿Ð¾ÑÐ²Ð»ÑÐµÑÑÑ Ð¸Ð»Ð¸ Ð¸ÑÑÐµÐ·Ð°ÐµÑ ÑÐ»ÐµÐ¼ÐµÐ½Ñ.
  //
  // ÐÐ¾ ÑÐ½Ð°ÑÐ°Ð»Ð° Ð´Ð¾Ð¶Ð¸Ð´Ð°ÐµÐ¼ÑÑ Ð¼ÐµÐ½Ñ: Ð¾Ð½Ð¾ ÑÐ¸ÑÑÐµÑÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð¾ÑÐ²ÐµÑÐ° ÑÐµÑÐ²ÐµÑÐ° ÑÐ¾
  // ÑÑÑÑÑÐ¸ÐºÐ°Ð¼Ð¸, Ð¸ ÑÑÑ, Ð·Ð°Ð¿ÑÑÐµÐ½Ð½ÑÐ¹ ÑÑÐ°Ð·Ñ Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÑÑÐ°Ð½Ð¸ÑÑ, Ð½Ðµ Ð½Ð°ÑÐ¾Ð´Ð¸Ð»
  // Ð½Ð¸ Ð¾Ð´Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ½ÐºÑÐ° â Ñ Ð½Ð¾Ð²Ð¸ÑÐºÐ° Ð¾ÑÑÐ°Ð²Ð°Ð»Ð¾ÑÑ Ð¿ÑÑÑ ÑÐ°Ð³Ð¾Ð² Ð²Ð¼ÐµÑÑÐ¾ ÑÐµÑÑÑÐ½Ð°Ð´ÑÐ°ÑÐ¸.
  useEffect(() => {
    if (!tourRunning) {
      setSteps([]);
      setIndex(0);
      return undefined;
    }

    startPath.current = location.pathname;
    setIndex(0);

    let attempts = 0;
    const timers = [];

    const fixSteps = () => {
      const menuReady = !!document.querySelector(selectorFor(ANCHORS.menuClients));

      if (!menuReady && attempts < MENU_WAIT_ATTEMPTS) {
        attempts += 1;
        timers.push(setTimeout(fixSteps, WAIT_STEP_MS));
        return;
      }

      setSteps(STEPS.filter((step) => isStepAvailable(step)));
    };

    fixSteps();

    return () => timers.forEach(clearTimeout);
    // location Ð² Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÑÑ Ð½Ðµ Ð½ÑÐ¶ÐµÐ½: Ð¿ÑÑÑ Ð·Ð°Ð¿Ð¾Ð¼Ð¸Ð½Ð°ÐµÐ¼ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð·, Ð½Ð° ÑÑÐ°ÑÑÐµ.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourRunning]);

  const step = steps[index];

  // Ð¡Ð»ÐµÐ´ÑÑÑÐ¸Ð¹ ÑÐ°Ð³, ÑÐ»ÐµÐ¼ÐµÐ½Ñ ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ ÐµÑÑÑ Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ. Ð¨Ð°Ð³, ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÑÑÐ¿ÐµÐ»
  // Ð¿ÑÐ¾Ð¿Ð°ÑÑÑ (Ð·Ð°ÐºÑÑÐ»Ð¸ Ð¼ÐµÐ½Ñ, ÑÑÐ»Ð¸ ÑÐ¾ ÑÑÑÐ°Ð½Ð¸ÑÑ), Ð¿ÑÐ¾ÑÑÐ¾ Ð¿ÐµÑÐµÑÐ°Ð³Ð¸Ð²Ð°ÐµÐ¼.
  const findAvailable = useCallback(
    (from, direction) => {
      for (let i = from; i >= 0 && i < steps.length; i += direction) {
        if (isStepAvailable(steps[i])) return i;
      }
      return -1;
    },
    [steps]
  );

  // Ð¢ÑÑ Ð²Ð¾Ð´Ð¸Ñ ÑÐµÐ»Ð¾Ð²ÐµÐºÐ° Ð¿Ð¾ ÑÐ°Ð·Ð´ÐµÐ»Ð°Ð¼, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð² ÐºÐ¾Ð½ÑÐµ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÐµÐ¼ ÐµÐ³Ð¾ ÑÑÐ´Ð°,
  // Ð¾ÑÐºÑÐ´Ð° Ð¾Ð½ Ð½Ð°ÑÐ°Ð», â Ð¸Ð½Ð°ÑÐµ Ð¾Ð½ Ð¾ÑÑÐ°Ð½ÐµÑÑÑ Ð½Ð° ÑÑÐ¶Ð¾Ð¹ ÑÑÑÐ°Ð½Ð¸ÑÐµ.
  const endTour = useCallback(
    (outcome, stepId, stepNumber) => {
      const back = startPath.current;
      startPath.current = null;

      // Ð¡Ð±ÑÐ°ÑÑÐ²Ð°ÐµÐ¼ ÑÐ°Ð³Ð¸ Ð´Ð¾ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°: Ð¸Ð½Ð°ÑÐµ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¹ ÑÐ°Ð³ ÑÐ½Ð¾Ð²Ð° ÑÑÐ°ÑÐ¸Ñ Ð½Ð°Ñ
      // Ð² ÑÐ²Ð¾Ð¹ ÑÐ°Ð·Ð´ÐµÐ», Ð¸ ÑÐµÐ»Ð¾Ð²ÐµÐº Ð²ÐµÑÐ½ÑÑÑÑ Ð½Ðµ ÑÑÐ´Ð°, Ð¾ÑÐºÑÐ´Ð° Ð½Ð°ÑÐ°Ð».
      setSteps([]);
      setIndex(0);

      finishTour(outcome, stepId, stepNumber);

      // ÐÑÐ¾Ð¿ÑÑÑÐ¸Ð» â ÑÐºÐ°Ð¶ÐµÐ¼, Ð³Ð´Ðµ ÐµÐ³Ð¾ Ð½Ð°Ð¹ÑÐ¸: Ð¸Ð½Ð°ÑÐµ Ð½Ð¾Ð²Ð¸ÑÐ¾Ðº ÑÐµÑÐ¸Ñ, ÑÑÐ¾ Ð¾Ð±ÑÑÐµÐ½Ð¸Ðµ
      // Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð· Ð¸ Ð±Ð¾Ð»ÑÑÐµ Ð½Ð¸ÐºÐ¾Ð³Ð´Ð°.
      if (outcome === 'skipped') alert.success(locale.ui.whereToFind);

      if (back) navigate(back);
    },
    [finishTour, navigate, locale]
  );

  const goTo = useCallback(
    (from, direction) => {
      const next = findAvailable(from, direction);

      if (next === -1) {
        endTour('finished', step?.id, index + 1);
        return;
      }

      setIndex(next);
    },
    [findAvailable, endTour, step, index]
  );

  const handleNext = useCallback(() => goTo(index + 1, 1), [goTo, index]);
  const handleBack = useCallback(() => goTo(index - 1, -1), [goTo, index]);
  const handleSkip = useCallback(() => endTour('skipped', step?.id, index + 1), [endTour, step, index]);

  // Ð¨Ð°Ð³ Ð¿ÑÐ¾ ÑÐ°Ð·Ð´ÐµÐ» Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ ÑÐ°Ð¼ ÑÐ°Ð·Ð´ÐµÐ»: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ¼Ð¾ÑÑÐ¸Ñ Ð½Ð° ÑÐ²Ð¾Ð¸ Ð¶Ð¸Ð²ÑÐµ
  // ÐºÐ»Ð¸ÐµÐ½ÑÑ Ð¸ ÑÐ´ÐµÐ»ÐºÐ¸, Ð° Ð½Ðµ ÑÐ»ÑÑÐ°ÐµÑ ÑÐ°ÑÑÐºÐ°Ð· Ñ ÑÑÐ¶Ð¾Ð¹ ÑÑÑÐ°Ð½Ð¸ÑÑ.
  useEffect(() => {
    if (!tourRunning || !step?.route) return;
    if (location.pathname === step.route) return;

    navigate(step.route);
  }, [tourRunning, step, location.pathname, navigate]);

  // ÐÐ¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐµÐ½Ð½Ð¾Ð³Ð¾ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ°. ÐÐµÑÐµÑÑÐ¸ÑÑÐ²Ð°ÐµÐ¼ Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ ÑÐ°Ð³Ð°, Ð¿ÑÐ¾ÐºÑÑÑÐºÐµ
  // Ð¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¸ ÑÐ°Ð·Ð¼ÐµÑÐ° Ð¾ÐºÐ½Ð° â Ð¸Ð½Ð°ÑÐµ Ð²ÑÑÐµÐ· ÑÐµÐ·Ð¶Ð°ÐµÑ Ð¾Ñ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ°.
  useLayoutEffect(() => {
    if (!tourRunning || !step) return undefined;

    if (!step.anchor) {
      setRect(null);
      return undefined;
    }

    let node = null;
    let attempts = 0;
    const timers = [];

    const update = () => {
      if (node) setRect(node.getBoundingClientRect());
    };

    // Ð Ð°Ð·Ð´ÐµÐ» ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¾ Ð¾ÑÐºÑÑÐ»ÑÑ Ð¸ ÐµÑÑ ÑÐ¸ÑÑÐµÑÑÑ â ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ° Ð¿Ð¾ÐºÐ° Ð½ÐµÑ. ÐÐ´ÑÐ¼ ÐµÐ³Ð¾
    // Ð½ÐµÐ´Ð¾Ð»Ð³Ð¾, Ð²Ð¼ÐµÑÑÐ¾ ÑÐ¾Ð³Ð¾ ÑÑÐ¾Ð±Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÑ Ð² Ð¿ÑÑÑÐ¾ÑÑ.
    const find = () => {
      node = document.querySelector(selectorFor(step.anchor));

      if (!node) {
        attempts += 1;
        if (attempts <= WAIT_ATTEMPTS) {
          timers.push(setTimeout(find, WAIT_STEP_MS));
        } else {
          setRect(null);
        }
        return;
      }

      update();

      if (typeof node.scrollIntoView === 'function') {
        node.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
        // ÐÐ¾ÑÐ»Ðµ Ð¿Ð»Ð°Ð²Ð½Ð¾Ð¹ Ð¿ÑÐ¾ÐºÑÑÑÐºÐ¸ ÐºÐ¾Ð¾ÑÐ´Ð¸Ð½Ð°ÑÑ Ð¼ÐµÐ½ÑÑÑÑÑ â Ð¾Ð±Ð½Ð¾Ð²Ð¸Ð¼ ÐµÑÑ ÑÐ°Ð·.
        timers.push(setTimeout(update, 350));
      }
    };

    find();

    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);

    return () => {
      timers.forEach(clearTimeout);
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
    };
  }, [tourRunning, step, location.pathname]);

  // Ð ÐµÐ°Ð»ÑÐ½ÑÐ¹ ÑÐ°Ð·Ð¼ÐµÑ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ â ÑÑÐ¾Ð±Ñ Ð¾Ð½Ð° Ð½Ðµ Ð²ÑÐ»ÐµÐ·Ð°Ð»Ð° Ð·Ð° ÐºÑÐ°Ð¹ ÑÐºÑÐ°Ð½Ð°.
  useLayoutEffect(() => {
    if (!cardRef.current) return;

    const { width, height } = cardRef.current.getBoundingClientRect();
    if (width && height) setCardSize({ width, height });
  }, [step, rect]);

  // ÐÐ»Ð°Ð²Ð¸Ð°ÑÑÑÐ°: Esc Ð·Ð°ÐºÑÑÐ²Ð°ÐµÑ, ÑÑÑÐµÐ»ÐºÐ¸ Ð»Ð¸ÑÑÐ°ÑÑ.
  useEffect(() => {
    if (!tourRunning) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        handleSkip();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        handleNext();
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        handleBack();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [tourRunning, handleNext, handleBack, handleSkip]);

  useEffect(() => {
    if (!tourRunning || !step) return;

    trackOnboarding(ONBOARDING_EVENTS.tourStepShown, {
      stepId: step.id,
      stepNumber: index + 1,
      total: steps.length,
    });
  }, [tourRunning, step, index, steps.length]);

  const position = useMemo(() => {
    if (!rect) return null;

    const viewport = { width: window.innerWidth, height: window.innerHeight };
    return computeCardPosition(rect, cardSize, viewport, step?.placement);
  }, [rect, cardSize, step]);

  if (!tourRunning || !step) return null;

  const text = locale.steps[step.textKey] || { title: '', text: '' };
  const centered = !rect;

  return (
    <div className={styles.layer} data-testid="onboarding-tour">
      {rect ? (
        <div
          className={styles.hole}
          style={{ top: rect.top - 4, left: rect.left - 4, width: rect.width + 8, height: rect.height + 8 }}
        />
      ) : (
        <div className={styles.plainBackdrop} />
      )}

      <TourCard
        ref={cardRef}
        title={text.title}
        text={text.text}
        stepNumber={index + 1}
        total={steps.length}
        ui={locale.ui}
        position={position}
        centered={centered}
        isFirst={index === 0}
        isLast={index === steps.length - 1}
        onNext={handleNext}
        onBack={handleBack}
        onSkip={handleSkip}
      />
    </div>
  );
};

export default OnboardingTour;
